import React from "react";

const Inventory = () => {
  return (
    <div className="container">
      <h2 className="text-center text-danger py-5">This Is Inventory</h2>
      <h1 className="fw-bold text-primary text-center py-5">
        {" "}
        Thanks For Visiting My Simple Ema john Website
      </h1>
    </div>
  );
};

export default Inventory;
